export default "__VITE_ASSET__DFSoPVNo__"